import { message } from 'antd';

import { call, put, takeEvery, all, fork, select, takeLatest } from 'redux-saga/effects'
import { getCoReportersAPI } from '../../../services/mis-service';
import { FETCH_CO_REPORTERS, FETCH_CO_REPORTERS_START, FETCH_CO_REPORTERS_SUCCESS, FETCH_CO_REPORTERS_ERROR, UNDO_REPORT_FROM_HOLD_QUEUE, UNDO_REPORT_FROM_HOLD_QUEUE_START, UNDO_REPORT_FROM_HOLD_QUEUE_SUCCESS, UNDO_REPORT_FROM_HOLD_QUEUE_ERROR, SET_CO_REPORTERS_FILTER } from '../../actions/mis/coReportersAction';

function* fetchCoRporters({ reportId }) {
    try {
        yield put({ type: FETCH_CO_REPORTERS_START })
        const response = yield call(getCoReportersAPI, reportId);

        if (response.success) {
            yield put({ type: FETCH_CO_REPORTERS_SUCCESS, coReporters: response.data.length > 0 ? [...response.data] : [] });
        } else {
            yield put({ type: FETCH_CO_REPORTERS_ERROR, error: response.error })
            message.error('Failed to fetch co-reporters!');
        }
    } catch (error) {
        yield put({ type: FETCH_CO_REPORTERS_ERROR, error })
        message.error('Failed to fetch co-reporters!');
    }
}


function* misCoReportersWatcher() {
    yield takeLatest(FETCH_CO_REPORTERS, fetchCoRporters)
}

export default function* rootSaga() {
    yield all([
        misCoReportersWatcher(),
    ]);
}